import { HomePage, CompetitionList, ClubListPage, AthleteList, Report1Page, Report2Page, Report3Page, Report4Page, Report5Page, PermissiongroupListPage,PermissiongroupEditPage, UserListPage, AthleteEditPage, UserEditPage, TraininggroupListPage, ClubEditPage, UserAddPage, CompetitionAddDSV7Page, CompetitionEditPage, AthleteDetails, CompetitionDetails, UserList, UserDetails, PermissiongroupDetails, TraininggroupList, PermissiongroupList, ClubDetails, ClubList, CompetitionEntrySend, AppSettingsPage, Stopwatch, AthleteLicenseUpdate, AthleteMedicalOverview, SquadList, SquadTimes } from './pages';
import { withNavigationWatcher } from './contexts/navigation';

const routes = [
    {
        path: '/home',
        element: HomePage
    },
   
    {
        path: '/athlete/list',
        element: AthleteList
    },
    {
        path: '/athlete/edit/:athleteId',
        element: AthleteDetails
    },
    {
        path: '/athlete/license-update',
        element: AthleteLicenseUpdate
    }
    ,
    {
        path: '/athlete/medical-overview',
        element: AthleteMedicalOverview
    }
    ,
    {
        path: '/competition/list',
        element: CompetitionList
    }    ,
    {
        path: '/competition/edit/:competitionId',
        element: CompetitionDetails
    }    ,
    {
        path: '/competition/entrysend/:competitionId',
        element: CompetitionEntrySend
    }    ,

    ,
    {
        path: '/club/list',
        element: ClubList
    }
    ,  {
        path: '/club/edit/:clubId',
        element: ClubDetails
    }
    ,
    {
        path: '/reports/AgeGroupRanking',
        element: Report1Page
    },
    {
        path: '/reports/top3',
        element: Report2Page
    },
    {
        path: '/reports/besttimesmatrix',
        element: Report3Page
    },
    {
        path: '/reports/squads',
        element: Report4Page
    },
    {
        path: '/reports/schoolgrades',
        element: Report5Page
    },
    {
        path: '/stopwatch',
        element: Stopwatch
    },
    {
        path: '/settings/permissiongroup/list',
        element: PermissiongroupList
    },
    {
        path: '/settings/permissiongroup/edit/:permissiongroupId',
        element: PermissiongroupDetails
    },
    {
        path: '/settings/app',
        element: AppSettingsPage
    },
    {
        path: '/traininggroup/list',
        element: TraininggroupList
    }
    ,
    {
        path: '/squad/list',
        element: SquadList
    }
    ,
    {
        path: '/squad/edit/:squadId',
        element: SquadTimes
    }
    ,
    {
        path: '/user/list',
        element: UserList
    },
   
    {
        path: '/user/edit/:userId',
        element: UserDetails
    }
];

export const appRoutes = routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});
